// Markaziy HTTP mijozi: barcha endpointlar bundan foydalanadi.
const API_URL = process.env.REACT_APP_API_URL || 'https://api.aidex.uz';

function toQuery(params = {}) {
    const entries = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null);
    if (!entries.length) return '';
    const qs = new URLSearchParams(entries).toString();
    return qs ? `?${qs}` : '';
}

async function fetchJson(path, { method = 'GET', body, signal, headers } = {}) {
    const res = await fetch(
        path.startsWith('http') ? path : `${API_URL}${path}`,
        {
            method,
            headers: {
                ...(body ? { 'Content-Type': 'application/json' } : {}),
                ...(headers || {}),
            },
            body: body ? JSON.stringify(body) : undefined,
            signal,
        }
    );

    // JSON bo'lmasa ham, xatoni to'g'ri ko'rsatish uchun
    let data;
    const text = await res.text();
    try { data = text ? JSON.parse(text) : null; } catch {
        data = { raw: text };
    }

    if (!res.ok) {
        const message = data?.message || `HTTP ${res.status}`;
        const err = new Error(message);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}

export const http = {
    get: (path, params, opts = {}) => fetchJson(`${path}${toQuery(params)}`, { ...opts }),
    post: (path, body, opts = {}) => fetchJson(path, { method: 'POST', body, ...opts }),
    API_URL,
};
